// Shared ACQ/DIV color language. Acquisitions read green, divestitures red,
// everywhere (Master Inventory popout, Transaction History, New Transaction).

export const ACQ_GREEN = "#3da763"
export const DIV_RED = "#c93939"
// A softer red for large surfaces like the Divestiture form button.
export const DIV_RED_SOFT = "#E06A60"

/**
 * Color for a transaction type. A negative net-acre value is treated as a
 * divestiture even if the type string says otherwise.
 */
export function txTypeColor(type: string, netAcres?: number): string {
  const isDiv = type === "DIV" || (netAcres !== undefined && netAcres < 0)
  return isDiv ? DIV_RED : ACQ_GREEN
}
